module.exports = __webpack_public_path__ + "assets/img/img-talk-01.ff5f5c58.jpg";